import { request } from "../utils/request"


export function getJGList(data) {
    return request({
        url: 'stuwebapi/train.project/xcustList',
        method: 'get',
        data: {}
    })
}
export function reLogin(data) {
    return request({
        url: 'stuwebapi/train.project/reLogin',
        method: 'post',
        data
    })
}
